<script setup lang="ts">
import { ImageOff } from '@lucide/vue'
import { ref, watch } from 'vue'

const props = defineProps<{ src?: string, alt: string, eager?: boolean, shade?: boolean }>()
const failed = ref(false)
watch(() => props.src, () => failed.value = false)
</script>

<template>
    <div class="relative h-full w-full overflow-hidden bg-[var(--c-poster)]">
        <img
            v-if="src && !failed"
            :src="src"
            :alt="alt"
            :loading="eager ? 'eager' : 'lazy'"
            :fetchpriority="eager ? 'high' : undefined"
            decoding="async"
            class="poster-image h-full w-full object-cover"
            referrerpolicy="no-referrer"
            @error="failed = true"
        >
        <div v-else class="absolute inset-0 grid place-items-center bg-[var(--c-poster)] text-[var(--c-text-faint)]">
            <div class="flex flex-col items-center gap-2">
                <ImageOff class="size-7" :stroke-width="1.5" />
                <span class="max-w-28 px-2 text-center text-xs text-[var(--c-text-muted)]">{{ alt }}</span>
            </div>
        </div>
        <div v-if="shade !== false" class="pointer-events-none absolute inset-0 from-black/55 via-transparent to-transparent bg-gradient-to-t opacity-70" />
    </div>
</template>

<style scoped>
.poster-image {
    transform: translateZ(0);
    transition: transform 360ms cubic-bezier(0.22, 1, 0.36, 1);
}

@media (hover: hover) and (pointer: fine) {
    :global(.group:hover) .poster-image {
        transform: translateZ(0) scale(1.025);
    }
}
</style>
